module.exports = __webpack_public_path__ + "img/carpenter.e24ae360.jpg";